export default __webpack_public_path__ + "static/media/0.44707496.svg";